import { Component, ReactNode } from 'react';
import { reportMykissClientError } from '@lib/errors/client';
import { ErrorBanner } from '../ErrorBanner/ErrorBanner';

interface IState {
  hasError: boolean;
}

interface IProps {
  children: ReactNode;
}

class MapboxErrorBoundary extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): IState {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    reportMykissClientError(error);
  }

  render(): ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <div className="mx-auto my-6 max-w-(--breakpoint-md)">
          <ErrorBanner
            errors={['An error occurred while loading the map. Refresh the page to try again.']}
          />
        </div>
      );
    }

    return children;
  }
}

// Default export as class component

export default MapboxErrorBoundary;
